// External Dependencies
import {
  CreateDocumentUploadRequest,
  DownloadDocumentUploadRequest,
  GetDocumentUploadsRequest,
} from '@presto-assistant/api_types/api/v1/documentUpload';
import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';

// Internal Dependencies
import { useTanstackMutation } from 'utils/api/index';
import { prestoApiClient } from 'utils/api/apiClient';

export const useGetDocumentUploads = (params: GetDocumentUploadsRequest['params']) => {
  return useQuery({
    queryFn: () => {
      return prestoApiClient.v1.documentUploadClient.getDocumentUploads({
        idRef: params.idRef,
        tableRef: params.tableRef,
      });
    },
    queryKey: ['documentUploads', params.tableRef, params.idRef],
  });
};

export const useCreateDocumentUpload = () => {
  const mutationFn = useCallback((body: CreateDocumentUploadRequest['body']) => {
    return prestoApiClient.v1.documentUploadClient.createDocumentUpload(body);
  }, []);

  return useTanstackMutation({
    mutationFn,
  });
};

export const useDownloadDocumentUpload = () => {
  const mutationFn = useCallback((params: DownloadDocumentUploadRequest['params']) => {
    return prestoApiClient.v1.documentUploadClient.downloadDocumentUpload(params);
  }, []);

  return useTanstackMutation({
    mutationFn,
  });
};
